import React from 'react'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

const FormSubmitted = ({ match: { url }, location: { state } }) => {
  const { formatMessage } = useIntl()

  if (!state || !state.success) {
    return (
      <div className="w-full h-full flex">
        <div className="h-full w-1/3 bg-primary flex justify-center items-center">
          <div className="w-2/3">
            <div className="text-white font-medium text-4xl">
              <FormattedMessage {...messages.inaccessibleTitle } />
            </div>

            <div className="text-white mt-6 w-2/3">
              <FormattedMessage {...messages.inaccessibleSubtitle } />
            </div>
          </div>
        </div>
        <div className="h-full w-2/3 flex justify-center items-center">
          <div className="">
            <FormattedMessage {...messages.inaccessibleBody } values={{
              link: <Link to={url.replace(/[^/]*$/, '')} className="text-primary">
                <FormattedMessage {...messages.inaccessibleLinkLabel } />
              </Link>
            }} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-full flex">
      <div className="h-full w-1/3 bg-primary flex justify-center items-center">
        <div className="w-2/3">
          <div className="text-white font-medium text-4xl">
            <FormattedMessage {...messages.title } />
          </div>

          <div className="text-white mt-6 w-2/3">
            <FormattedMessage {...messages.subtitle } />
          </div>
        </div>
      </div>
      <div className="h-full w-2/3 flex justify-center items-center">
        <div className="">
          <div className="w-2/3">
            <div className="font-medium text-4xl">
              <FormattedMessage {...messages.ctaTitle } />
            </div>

            <div className="mt-6">
              <FormattedMessage {...messages.ctaSubtitle } />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3 mt-6 text-center">
            {[
              ['iCloud', 'https://www.icloud.com/mail'],
              ['Outlook (O365, Hotmail, etc.)', 'https://outlook.live.com/owa/?nlp=1'],
              ['Gmail', 'https://accounts.google.com/AccountChooser?service=mail&continue=https://mail.google.com/mail/']
            ].map(([name, href]) => (
              <a target="_blank" href={href} key={name} className="py-8 px-4 border border-primary text-primary hover:bg-primary hover:text-white cursor-pointer transition duration-200 ease-in-out overflow-hidden antialiased">
                { name }
              </a>
            )) }
          </div>

          <div className="text-sm mt-6">
            <FormattedMessage {...messages.ctaHint } />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormSubmitted
